<template>
  <div class="single-product">
    <div class="single-product__name">{{ couponName }}</div>
    <div class="count-area">
      <button><span class="icon-icon_less" @click="handleMinus"></span></button>
      <div title="1" class="quantity">{{ currentQuantity }}</div>
      <button><span class="icon-icon_add" @click="handlePlus"></span></button>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  props: {
    coupon: {
      required: true,
      type: Object
    },
    limit: {
      //限制數量
      required: false,
      type: Number
    }
  },
  computed: {
    couponName() {
      return get(this.coupon, 'name');
    },
    currentQuantity: {
      get() {
        return this.coupon.qty ?? 0;
      },
      set(val) {
        this.$emit('updateQty', {
          type: this.coupon.type,
          qty: val
        });
      }
    }
  },
  methods: {
    handlePlus(e) {
      e.preventDefault();

      this.currentQuantity = this.currentQuantity + 1;
    },
    handleMinus(e) {
      e.preventDefault();
      this.currentQuantity
        ? (this.currentQuantity = this.currentQuantity - 1)
        : (this.currentQuantity = 0);
    }
  },
  created() {
    this.currentQuantity = this.coupon.qty;
  }
};
</script>
